<i18n src="./resources/locales.json"></i18n>

<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="460" content-class="create-list-dialog">
    <v-card>
      <v-card-title class="headline">
        {{ $t('header.title') }}
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4 pb-8">
        <v-form ref="form" v-model="isValidForm" lazy-validation>
          <v-text-field
            v-model="list.name"
            ref="listName"
            type="text"
            :rules="listNameRules"
            :label="$t('form.listName')"
          />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">
          {{ $t('buttons.cancel') }}
        </v-btn>
        <v-btn color="primary" depressed :disabled="!isValidForm" :loading="isLoading" @click="save">
          {{ $t('buttons.create') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { CrmService } from '@/services';
import { mapActions } from 'vuex';

export default {
  name: 'EcsListDialog',

  data() {
    return {
      dialog: false,
      isLoading: false,
      list: {},
      isValidForm: true,
      listNameRules: [
        name => name !== '' || this.$t('validations.emptyListName'),
        name => (name && name.length <= 80) || this.$t('validations.lengthLimit')
      ],
      event: {
        updated: 'list-updated',
        cancelled: 'list-cancelled'
      }
    };
  },

  computed: {},

  methods: {
    ...mapActions(['snackbarErrorMessage', 'snackbarSuccessMessage']),

    async open(list = {}) {
      this.dialog = true;
      this.list = list;
      this.isLoading = false;
      await this.$nextTick();
      this.resetForm();
      return new Promise((resolve, reject) => {
        this.$once(this.event.updated, resolve);
        this.$once(this.event.cancelled, reject);
      });
    },

    close() {
      this.resetForm();
      this.dialog = false;
      this.$off(this.event.updated);
      this.$emit(this.event.cancelled);
    },

    async save() {
      this.validateForm();
      await this.$nextTick();
      if (!this.isValidForm) {
        return;
      }

      this.isLoading = true;

      CrmService.createList(this.list)
        .then(() => {
          this.$off(this.event.cancelled);
          this.$emit(this.event.updated, { ...this.list });
          this.snackbarSuccessMessage(this.$t('messages.create.success', { ...this.list }));
          this.close();
        })
        .catch(() => {
          this.snackbarErrorMessage(this.$t('messages.create.error'));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    validateForm() {
      this.$refs.form.validate();
    },

    resetForm() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style src="./scoped.scss" scoped lang="scss"></style>
